/**
 * Ingredient COA — expand/collapse PDF links in place.
 * Opening one closes any other open panel.
 * Toggle is scoped to its own [data-nnh-coa] root (avoids ID collisions).
 * Safe to load multiple times (window guard).
 * No optional chaining / nullish coalescing (Safari <13.4).
 */
(function () {
  if (window.__nnhIngredientCoaInit) return;
  window.__nnhIngredientCoaInit = true;

  function getPanel(toggle) {
    if (!toggle) return null;
    var root = toggle.closest('[data-nnh-coa]');
    if (!root) return null;
    return root.querySelector('.nnh-ingredient-coa__panel');
  }

  function closePanel(toggle) {
    if (!toggle) return;
    var panel = getPanel(toggle);
    toggle.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('hidden', '');
  }

  function openPanel(toggle) {
    if (!toggle) return;
    var panel = getPanel(toggle);
    toggle.setAttribute('aria-expanded', 'true');
    if (panel) panel.removeAttribute('hidden');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nnh-coa-toggle]');
    if (!toggle) return;

    e.preventDefault();
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';

    var allToggles = document.querySelectorAll('[data-nnh-coa-toggle]');
    for (var i = 0; i < allToggles.length; i++) {
      var other = allToggles[i];
      if (other === toggle) continue;
      if (other.getAttribute('aria-expanded') === 'true') {
        closePanel(other);
      }
    }

    if (isOpen) {
      closePanel(toggle);
    } else {
      openPanel(toggle);
    }
  });
})();
